import { useEffect, useState } from "react";
import MasterLayout from "./MasterLayout";
import { masterFetch } from "./masterApi";
import API_URL from "../../utils/apiUrl";
import { masterAuth } from "./masterApi";

export default function MasterReports() {
  const [period, setPeriod] = useState("weekly");
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState(false);

  async function load(p) {
    setBusy(true);
    try { setData(await masterFetch(`/reports/${p}`)); }
    catch (e) { alert(e.message); }
    finally { setBusy(false); }
  }
  useEffect(() => { load(period); }, [period]);

  function downloadPdf() {
    const url = `${API_URL}/api/master/reports/${period}/pdf`;
    const tok = masterAuth.getToken();
    fetch(url, { headers: { Authorization: `Bearer ${tok}` } })
      .then(r => r.blob())
      .then(b => {
        const a = document.createElement("a");
        a.href = URL.createObjectURL(b);
        a.download = `rental-report-${period}.pdf`;
        a.click();
      });
  }

  return (
    <MasterLayout>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline" }}>
        <h1 style={{ margin: 0, fontSize: 26 }}>Rental reports</h1>
        <button data-testid="download-pdf" onClick={downloadPdf} style={btnPrimary}>↓ Download PDF</button>
      </div>
      <div style={{ opacity: 0.55, fontSize: 13, marginBottom: 20 }}>Automated platform-wide snapshots.</div>

      <div style={{ display: "flex", gap: 8, marginBottom: 24 }}>
        {["weekly", "monthly"].map(p => (
          <button key={p} data-testid={`period-${p}`} onClick={() => setPeriod(p)} style={{
            ...btnGhost,
            background: period === p ? "rgba(139,92,246,0.18)" : "transparent",
            color: period === p ? "#fff" : "#a89ec9",
            border: period === p ? "1px solid rgba(139,92,246,0.4)" : "1px solid #3a2a55",
          }}>{p}</button>
        ))}
      </div>

      {busy && <div style={{ opacity: 0.5 }}>Loading…</div>}

      {data && !busy && (
        <>
          <div style={{ fontSize: 13, opacity: 0.7, marginBottom: 16 }}>{data.label}</div>
          <div data-testid="report-stats" style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(170px,1fr))", gap: 14, marginBottom: 28 }}>
            <Stat label="Tenants total" value={data.total_tenants} accent="#8b5cf6" />
            <Stat label="Active" value={data.active} accent="#10b981" />
            <Stat label="Frozen" value={data.frozen} accent="#f59e0b" />
            <Stat label="Deactivated" value={data.deactivated} accent="#ef4444" />
            <Stat label={`New (${period})`} value={data.new_tenants} accent="#06b6d4" />
            <Stat label="Master actions" value={data.master_actions} accent="#a855f7" />
            <Stat label="Revenue" value={data.revenue.toFixed(2)} accent="#34d399" />
          </div>

          <h2 style={{ fontSize: 13, letterSpacing: 2, opacity: 0.6, margin: "0 0 10px" }}>TENANT SNAPSHOT</h2>
          <div style={{ background: "#0f0a1c", border: "1px solid #1f1232", borderRadius: 12, overflow: "hidden" }}>
            <div style={{ display: "grid", gridTemplateColumns: "2fr 1fr 1fr 1fr 1fr", padding: "12px 16px", fontSize: 11, letterSpacing: 2, opacity: 0.5, borderBottom: "1px solid #1f1232" }}>
              <span>NAME</span><span>PLAN</span><span>STATUS</span><span>SUBSCRIPTION</span><span>REGION</span>
            </div>
            {data.per_tenant.map(r => (
              <div key={r.id} style={{ display: "grid", gridTemplateColumns: "2fr 1fr 1fr 1fr 1fr", padding: "10px 16px", borderBottom: "1px solid #1a1029", fontSize: 13 }}>
                <span>{r.name}</span>
                <span style={{ opacity: 0.7 }}>{r.plan}</span>
                <span style={{ opacity: 0.7 }}>{r.status}</span>
                <span style={{ opacity: 0.7 }}>{r.subscription_status || "—"}</span>
                <span style={{ opacity: 0.7 }}>{r.data_region}</span>
              </div>
            ))}
          </div>
        </>
      )}
    </MasterLayout>
  );
}

function Stat({ label, value, accent }) {
  return (
    <div style={{ background: "#0f0a1c", border: "1px solid #1f1232", padding: 16, borderRadius: 12 }}>
      <div style={{ fontSize: 10, letterSpacing: 2, opacity: 0.5, marginBottom: 6 }}>{label.toUpperCase()}</div>
      <div style={{ fontSize: 26, fontWeight: 700, color: accent }}>{value}</div>
    </div>
  );
}

const btnPrimary = { padding: "9px 16px", background: "linear-gradient(135deg,#8b5cf6,#a855f7)", color: "#fff", border: "none", borderRadius: 8, cursor: "pointer", fontWeight: 600, fontSize: 13, fontFamily: "inherit" };
const btnGhost = { padding: "8px 14px", borderRadius: 8, cursor: "pointer", fontSize: 12, fontFamily: "inherit", letterSpacing: 1 };
